import React from "react";
import * as PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { PoliciesEditor } from "../../components/profileEditors/PoliciesEditor";

export function PoliciesTab({ provider, setProvider }) {
    return (
        <Box sx={{ p: '5px', pb: '25px' }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
                Policies
            </Typography>
            <PoliciesEditor provider={provider} setProvider={setProvider} showSaveButton={true} />
        </Box>
    );
}

PoliciesTab.propTypes = {
    provider: PropTypes.shape({
        id: PropTypes.string.isRequired,
        cancellationPolicy: PropTypes.string,
        lateArrivalPolicy: PropTypes.string,
    }).isRequired,
    setProvider: PropTypes.func.isRequired,
};


